<template>
  <div id="main-app" class="">
    <template v-if="isLoading">
      <SplashScreen></SplashScreen>
    </template>
    <template v-else>
      <router-view></router-view>
      <BottomDrawer></BottomDrawer>
    </template>
  </div>
</template>

<script setup>
import WebApp from '@twa-dev/sdk'

import { ref } from 'vue'
import { signIn, meTelegram } from '@/services'
import { RouterView, useRouter } from 'vue-router'
import { useConstantStore } from '@/stores/constant'
import { useGameStore } from '@/stores/game'
import { useUserStore } from '@/stores/user'
import BottomDrawer from './components/BottomDrawer.vue'
import SplashScreen from './components/SplashScreen.vue'

const router = useRouter()
const isLoading = ref(true)

const initData = ''
// 'query_id=AAFYUWUhAAAAAFhRZSEjh7kr&user=%7B%22id%22%3A560288088%2C%22first_name%22%3A%22Ramazan%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22raximora%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2Fx9WsBtaZXXbWqY3eQQ0H99gh_nZXNG4hkufDjbcrBds.svg%22%7D&auth_date=1732001893&signature=40Zqa1dz7vo5Ta7t8B5zpbXGOvbuUBWfcQ2oTXMZqknZXoPK8xZIzt9DfVPkd0AxY3rKA_fkCrPn1tU00GPNCQ&hash=1ac11d1d5ea2ba28b1aabbb43a3c61687a8f462b8fd843c2c5f30872ac1bfed2'
//  'query_id=AAFi9ylWAAAAAGL3KVaKi4K1&user=%7B%22id%22%3A1445590882%2C%22first_name%22%3A%22Ahmet%22%2C%22last_name%22%3A%22K%C3%BC%C3%A7%C3%BCk%22%2C%22username%22%3A%22kucukahmet%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%7D&auth_date=1721228283&hash=c8ef107b7d5a4f3a594ea702f1ced3fa89a193872c152c279307677ecdf741d7'

const goInside = async () => {
  const constantStore = useConstantStore()
  const gameStore = useGameStore()
  const userStore = useUserStore()
  await constantStore.fetchConstants()
  await gameStore.fetchUserSync()
  await gameStore.fetchSync()
  gameStore.startCalculateInterval()
  gameStore.startClaimInterval()
  gameStore.startClickCalculateInterval()

  setTimeout(() => {
    isLoading.value = false
  }, 1000)
}

const checkAuthentication = async () => {
  isLoading.value = true
  const userStore = useUserStore()
  const authToken = localStorage.getItem('auth-token') || null
  if (authToken) {
    try {
      const res = await meTelegram()
      console.log('ME TELEGRAM RESPONSEss : ', res)
      userStore.setUser(res.data)
      setTimeout(() => {
        goInside()
      }, 500)
    } catch {
      localStorage.clear()
      router.replace({ name: 'ErrorView' })
      isLoading.value = false
    }
  } else {
    try {
      const res = await signIn({ init_data: WebApp.initData || initData })
      console.log('AUTH RESPONSE : ', res)
      localStorage.setItem('auth-token', res.data.auth_token)
      userStore.setUser(res.data.user)

      setTimeout(() => {
        goInside()
      }, 500)
    } catch (err) {
      console.error(err)
      router.replace({ name: 'ErrorView' })
      isLoading.value = false
    }
  }
}

checkAuthentication()

// newWeb3Modal()
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.black-icon path {
  fill: #000000 !important;
}
.green-icon path {
  fill: #39d148 !important;
}
.red-icon path {
  fill: #b61818 !important;
}
.white-icon path {
  fill: #f6f6f6 !important;
}
.arrow_icon_color path {
  fill: #a2a7bc !important;
}
</style>
